export default "__VITE_ASSET__RLQ3aN02__"